// extracted by mini-css-extract-plugin
export default {"sub":"AddAssetDialog_sub__shfFB","body":"AddAssetDialog_body__DqOIC","tabs":"AddAssetDialog_tabs__-Dr-k","tab":"AddAssetDialog_tab__SgW5q","tabOn":"AddAssetDialog_tabOn__klZuq"};